// Accent presets (keys must match ADMIN_THEME_ACCENTS in the backend
// prod_mgmt_be/store/models_admin_theme.py) and light/dark surfaces for the panel theme. The chosen
// values are published as CSS variables (see ThemePrefs.tsx) so CSS files and
// inline styles follow the theme; MUI gets the hex values directly.

export type ThemeMode = "light" | "dark";

export interface Accent {
  label: string;
  main: string; // buttons, active states
  dark: string; // hover / text on soft backgrounds
  light: string; // MUI palette.primary.light
  rgb: string; // "r, g, b" of main, for rgba(var(--brand-rgb), a)
}

export const ACCENTS: Record<string, Accent> = {
  orange: { label: "Orange", main: "#F97316", dark: "#EA580C", light: "#FDBA74", rgb: "249, 115, 22" },
  blue: { label: "Blue", main: "#2563EB", dark: "#1D4ED8", light: "#93C5FD", rgb: "37, 99, 235" },
  green: { label: "Green", main: "#16A34A", dark: "#15803D", light: "#86EFAC", rgb: "22, 163, 74" },
  teal: { label: "Teal", main: "#0D9488", dark: "#0F766E", light: "#5EEAD4", rgb: "13, 148, 136" },
  purple: { label: "Purple", main: "#7C3AED", dark: "#6D28D9", light: "#C4B5FD", rgb: "124, 58, 237" },
  indigo: { label: "Indigo", main: "#4F46E5", dark: "#4338CA", light: "#A5B4FC", rgb: "79, 70, 229" },
  pink: { label: "Pink", main: "#DB2777", dark: "#BE185D", light: "#F9A8D4", rgb: "219, 39, 119" },
  red: { label: "Red", main: "#DC2626", dark: "#B91C1C", light: "#FCA5A5", rgb: "220, 38, 38" },
  forest: { label: "Forest", main: "#006400", dark: "#004B00", light: "#8FD18F", rgb: "0, 100, 0" },
  emerald: { label: "Emerald", main: "#006241", dark: "#004A31", light: "#7FCBAE", rgb: "0, 98, 65" },
  navy: { label: "Navy", main: "#1E3A8A", dark: "#172E6E", light: "#A5B8E8", rgb: "30, 58, 138" },
  maroon: { label: "Maroon", main: "#7F1D1D", dark: "#661717", light: "#E8A8A8", rgb: "127, 29, 29" },
  deep_teal: { label: "Deep Teal", main: "#115E59", dark: "#0D4A46", light: "#84CFC8", rgb: "17, 94, 89" },
};

export const DEFAULT_ACCENT = "orange";

export interface Surfaces {
  pageBg: string; // page background behind cards
  surface: string; // cards, dialogs, header
  surface2: string; // table heads, hovered rows, inputs
  border: string;
  text: string;
  muted: string;
  heading: string;
  shadow: string;
}

export const SURFACES: Record<ThemeMode, Surfaces> = {
  light: {
    pageBg: "#F7F7F9",
    surface: "#FFFFFF",
    surface2: "#FAFAFB",
    border: "rgba(15, 23, 42, 0.08)",
    text: "#1F2937",
    muted: "#6B7280",
    heading: "#181C32",
    shadow: "0 1px 2px rgba(15, 23, 42, 0.04), 0 8px 24px rgba(15, 23, 42, 0.05)",
  },
  dark: {
    pageBg: "#0F1115",
    surface: "#181B22",
    surface2: "#20242D",
    border: "rgba(255, 255, 255, 0.09)",
    text: "#E5E7EB",
    muted: "#9CA3AF",
    heading: "#F3F4F6",
    shadow: "0 1px 2px rgba(0, 0, 0, 0.4), 0 8px 24px rgba(0, 0, 0, 0.35)",
  },
};
